// frontend/src/pages/Contact.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/common/Icon';
import Card from '../components/common/Card';
import Input from '../components/common/Input';
import Button from '../components/common/Button';

// ============================================================
// اطلاعات تماس
// ============================================================
const CONTACT_INFO = [
  {
    icon: 'phone',
    label: 'تلفن تماس',
    value: '083-۰۰۰۰۰۰۰',
    sub: 'ساعات پاسخگویی: ۹ تا ۱۷',
    href: 'tel:0830000000',
  },
  {
    icon: 'mail',
    label: 'ایمیل',
    value: 'info@football-paveh.ir',
    sub: 'پاسخگویی ظرف ۲۴ ساعت',
    href: 'mailto:info@football-paveh.ir',
  },
  {
    icon: 'map-pin',
    label: 'آدرس',
    value: 'کرمانشاه، شهرستان پاوه میدان انقلاب',
    sub: 'ساختمان هیئت فوتبال شهرستان پاوه، طبقه همکف',
    href: '#',
  },
  {
    icon: 'clock',
    label: 'ساعات کاری',
    value: 'شنبه تا چهارشنبه',
    sub: '۸:۳۰ تا ۱۷:۰۰',
    href: null,
  },
];

const SOCIAL_LINKS = [
  { icon: 'instagram', label: 'اینستاگرام', url: '#', color: 'text-pink-600 bg-pink-50 hover:bg-pink-100' },
  { icon: 'telegram', label: 'تلگرام', url: 'https://t.me/footballPaveh1405', color: 'text-blue-600 bg-blue-50 hover:bg-blue-100' },
  { icon: 'globe', label: 'وب‌سایت', url: 'football-paveh.ir', color: 'text-slate-600 bg-slate-50 hover:bg-slate-100' },
  { icon: 'twitter', label: 'توییتر', url: '#', color: 'text-sky-600 bg-sky-50 hover:bg-sky-100' },
];

// ============================================================
// کامپوننت اصلی
// ============================================================
export default function Contact() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (error) setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // اعتبارسنجی ساده
    if (!form.name || !form.email || !form.message) {
      setError('لطفاً تمام فیلدهای ضروری را پر کنید.');
      setLoading(false);
      return;
    }

    try {
      // در صورت وجود API ارسال پیام
      // await sendContactFormApi(form);
      setSubmitted(true);
      setForm({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => setSubmitted(false), 5000);
    } catch (err) {
      setError(err?.response?.data?.message || 'ارسال پیام با خطا مواجه شد.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="min-h-screen py-16 animate-fade-in">
      <div className="container-page">
        {/* =========================================================
            HEADER
        ========================================================= */}
        <div className="relative mb-12 overflow-hidden rounded-3xl bg-gradient-to-br from-slate-900 via-slate-800 to-emerald-900 p-8 text-white shadow-2xl md:p-12">
          <div className="absolute -right-20 -top-20 h-64 w-64 rounded-full bg-emerald-500/10 blur-3xl" />
          <div className="absolute -bottom-20 -left-20 h-64 w-64 rounded-full bg-lime-500/10 blur-3xl" />

          <div className="relative flex flex-col items-center text-center md:flex-row md:justify-between md:text-right">
            <div>
              <div className="mb-3 flex items-center justify-center gap-2 text-sm font-bold text-emerald-300 md:justify-start">
                <span className="h-2 w-2 animate-pulse rounded-full bg-emerald-400" />
                ارتباط با هیئت فوتبال شهرستان پاوه
              </div>
              <h1 className="text-3xl font-black tracking-tight md:text-4xl lg:text-5xl">
                در ارتباط باشید
              </h1>
              <p className="mt-3 max-w-2xl text-sm leading-7 text-white/60 md:text-base">
                ما خوشحال می‌ شویم نظرات، پیشنهادات و سوالات شما را بشنویم.
                از طریق فرم تماس یا اطلاعات زیر با ما در ارتباط باشید.
              </p>
            </div>

            <div className="mt-4 flex shrink-0 items-center gap-3 md:mt-0">
              <div className="rounded-2xl border border-white/10 bg-white/5 px-5 py-3 backdrop-blur-sm">
                <div className="text-center text-xs font-bold text-white/40 md:text-right">
                  پاسخگویی
                </div>
                <div className="mt-1 text-center text-sm font-black text-white md:text-right">
                  ۲۴ ساعته
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid gap-8 lg:grid-cols-5">
          <div className="space-y-6 lg:col-span-2">
            <h2 className="text-2xl font-black text-text-dark">اطلاعات تماس</h2>
            <p className="text-sm text-slate-500">
              از طریق راه‌های زیر می‌ توانید با ما در ارتباط باشید.
            </p>

            <div className="space-y-4">
              {CONTACT_INFO.map((item) => (
                <div
                  key={item.label}
                  className="group flex items-start gap-4 rounded-2xl border border-slate-200 bg-white p-5 transition-all hover:border-emerald-200 hover:shadow-md"
                >
                  <div className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-emerald-50 text-emerald-600 transition-colors group-hover:bg-emerald-500 group-hover:text-white">
                    <Icon name={item.icon} className="h-5 w-5" />
                  </div>
                  <div>
                    <h3 className="text-sm font-bold text-slate-400">{item.label}</h3>
                    {item.href ? (
                      <a
                        href={item.href}
                        className="text-base font-black text-text-dark transition-colors hover:text-emerald-600"
                      >
                        {item.value}
                      </a>
                    ) : (
                      <p className="text-base font-black text-text-dark">{item.value}</p>
                    )}
                    {item.sub && <p className="mt-1 text-xs text-slate-400">{item.sub}</p>}
                  </div>
                </div>
              ))}
            </div>

            <div>
              <h3 className="mb-3 text-sm font-bold text-slate-400">ما را دنبال کنید</h3>
              <div className="flex flex-wrap gap-2">
                {SOCIAL_LINKS.map((item) => (
                  <a
                    key={item.label}
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-bold transition hover:-translate-y-0.5 ${item.color}`}
                  >
                    <Icon name={item.icon} className="h-4 w-4" />
                    {item.label}
                  </a>
                ))}
              </div>
            </div>

            <div className="overflow-hidden rounded-2xl border border-slate-200">
              <iframe
                src="https://maps.google.com/maps?q=Paveh,+Kermanshah+Province&output=embed"
                width="100%"
                height="200"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="نقشه هیئت فوتبال شهرستان پاوه"
                className="w-full"
              />
            </div>
          </div>

          <div className="lg:col-span-3">
            <Card hover={false} className="border-slate-200 bg-white p-6 shadow-sm md:p-8">
              <h2 className="mb-6 text-2xl font-black text-text-dark">ارسال پیام</h2>

              {submitted && (
                <div className="mb-4 flex items-start gap-3 rounded-xl border border-emerald-100 bg-emerald-50 p-4 text-emerald-700">
                  <Icon name="check-circle" className="h-5 w-5 shrink-0" />
                  <div>
                    <p className="font-bold">پیام شما با موفقیت ارسال شد.</p>
                    <p className="text-sm">به زودی با شما تماس خواهیم گرفت.</p>
                  </div>
                </div>
              )}

              {error && (
                <div className="mb-4 flex items-start gap-3 rounded-xl border border-red-100 bg-red-50 p-4 text-red-700">
                  <Icon name="alert-circle" className="h-5 w-5 shrink-0" />
                  <div>
                    <p className="font-bold">خطا در ارسال پیام</p>
                    <p className="text-sm">{error}</p>
                  </div>
                </div>
              )}

              <form onSubmit={handleSubmit} className="space-y-5">
                <div className="grid gap-5 sm:grid-cols-2">
                  <Input
                    label="نام و نام خانوادگی"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="نام خود را وارد کنید"
                    required
                  />
                  <Input
                    label="ایمیل"
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={handleChange}
                    placeholder="ایمیل خود را وارد کنید"
                    required
                  />
                </div>

                <Input
                  label="موضوع"
                  name="subject"
                  value={form.subject}
                  onChange={handleChange}
                  placeholder="موضوع پیام را وارد کنید"
                />

                <div>
                  <label className="mb-1.5 block text-sm font-bold text-slate-700">متن پیام <span className="mr-1 font-black text-red-500" aria-hidden="true">*</span></label>
                  <textarea
                    name="message"
                    rows="6"
                    value={form.message}
                    onChange={handleChange}
                    className="w-full rounded-xl border-2 border-slate-200 p-4 text-sm outline-none transition-all focus:border-emerald-500 focus:shadow-lg focus:shadow-emerald-500/10"
                    placeholder="پیام خود را بنویسید..."
                    required
                  />
                </div>

                <Button
                  type="submit"
                  variant="primary"
                  size="lg"
                  disabled={loading}
                  className="w-full md:w-auto"
                >
                  {loading ? (
                    <>
                      <span className="h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
                      در حال ارسال...
                    </>
                  ) : (
                    <>
                      ارسال پیام
                      <Icon name="arrowLeft" className="h-4 w-4" />
                    </>
                  )}
                </Button>
              </form>
            </Card>
          </div>
        </div>
        <div className="mt-12 rounded-3xl bg-gradient-to-br from-emerald-50 to-lime-50 p-8 text-center shadow-sm md:p-10">
          <h2 className="text-2xl font-black text-text-dark">آماده همکاری با شما هستیم</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-7 text-slate-500">
            اگر باشگاه، مربی، بازیکن یا سازمان ورزشی هستید، خوشحال می‌ شویم
            با شما همکاری کنیم. تیم ما آماده پاسخگویی به سوالات شماست.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 rounded-2xl bg-emerald-600 px-6 py-3 text-sm font-black text-white shadow-lg shadow-emerald-500/20 transition hover:-translate-y-1 hover:bg-emerald-700"
            >
              درباره ما
              <Icon name="arrowLeft" className="h-4 w-4" />
            </Link>
            <Link
              to="/clubs"
              className="inline-flex items-center gap-2 rounded-2xl border border-slate-200 bg-white px-6 py-3 text-sm font-bold text-slate-600 transition hover:-translate-y-1 hover:border-emerald-200 hover:bg-emerald-50"
            >
              باشگاه‌های عضو
              <Icon name="shield" className="h-4 w-4" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
